import * as React from 'react';
import { memo } from 'react';

const SvgTrendingUpV2 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m19.531 4.996-7.875 7.875L8.375 9.59l-5.906 5.906", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M19.531 10.246v-5.25h-5.25", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgTrendingUpV2);

export { Memo as default };
